import React, { memo } from "react";
import Dropdown from "react-dropdown";

const DropdownC = memo(
  ({
    value,
    error,
    width,
    label,
    options,
    message,
    onChange,
    disabled,
    placeholder,
  }) => {
    return (
      <div className={`flex flex-col gap-y-1 relative ${width} `}>
        {label && <label className="label ">{label}</label>}
        <Dropdown
          value={value}
          options={options}
          onChange={onChange}
          optionRen
          disabled={disabled}
          placeholder={placeholder}
          className={` ${error && "errorDropdown "} h-14 `}
          controlClassName="rounded-xl border border-borderColor  font-hkBold text-inputColor "
        />
        {error && <h5 className="errorMessage">{message}</h5>}
      </div>
    );
  }
);

DropdownC.displayName = "Dropdown";
export default DropdownC;
